import type { Variants } from "framer-motion";

const easeOutExpo: [number, number, number, number] = [0.16, 1, 0.3, 1];

/**
 * Entrada de página / bloco — opacidade, leve Y e blur (estilo www + login).
 * Com `prefers-reduced-motion`, remove blur e encurta duração.
 */
export function publicPageReveal(reducedMotion: boolean | null): Variants {
  if (reducedMotion) {
    return {
      hidden: { opacity: 0, y: 8 },
      visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.22, ease: "easeOut" },
      },
    };
  }
  return {
    hidden: {
      opacity: 0,
      y: 22,
      filter: "blur(12px)",
      scale: 0.988,
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      scale: 1,
      transition: { duration: 0.5, ease: easeOutExpo },
    },
  };
}

/** Container com stagger leve para filhos `motion.*` com variantes `publicStaggerItem`. */
export function publicStaggerContainer(reducedMotion: boolean | null): Variants {
  return {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: reducedMotion ? 0 : 0.06,
        delayChildren: reducedMotion ? 0 : 0.04,
      },
    },
  };
}

export function publicStaggerItem(reducedMotion: boolean | null): Variants {
  if (reducedMotion) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.18 } },
    };
  }
  return {
    hidden: { opacity: 0, y: 12, filter: "blur(8px)" },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.38, ease: easeOutExpo },
    },
  };
}
